var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Taotle-Kaart---2",
    transform: "translate(-52.000000, -596.000000)",
    stroke: "#FFCD00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(32.000000, 578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(19.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L5,8",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4 L9,4",
    id: "Path-2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusYellow);
export default __webpack_public_path__ + "static/media/Icon_Plus_Yellow.cf88bd877372bcc9d7ecb452de965dad.svg";
export { ForwardRef as ReactComponent };